import Commons from '../../../../Services/Common/Common';

export const M_TBM_CUSTOM_06_Schema = {
  mapper: {
    save1: {
      TbmCd: (row) => Commons.EncryptAES(row.tbmCd) || '',
      CompleteYn: (row) => Commons.EncryptAES('Y') || '',
      SignLocation: (row) =>
        Commons.EncryptAES(row.signLocation ?? '') || '',
      UserId: (_, context) => context.userInfo?.userid,
    },
  },
};
